// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CopyTradingPanel } from '@front/controls/panels/CopyTradingPanel';
import TvCopyTradingPanelTemplate from '../TradingPlatformTemplates/TvCopyTradingPanelTemplate.html';
import { Resources } from '@shared/localizations/Resources';
export class TvCopyTradingPanel extends CopyTradingPanel {
    constructor() {
        super();
    }
    localize() {
        super.localize();
        void this.set({
            btnStartText: Resources.getResource('panel.CopyTrading.RowControl.ButtonStart.Text'),
            btnStopText: Resources.getResource('panel.CopyTrading.RowControl.ButtonStop.Text')
        });
    }
}
CopyTradingPanel.extendWith(TvCopyTradingPanel, {
    data: () => ({
        btnStartText: '',
        btnStopText: ''
    }),
    partials: {
        bodyPartial: TvCopyTradingPanelTemplate
    }
});
